import React from 'react';
import Icon from '.';

const AnnotationsIcon = props => (
	<Icon {...props} viewBox="0 0 32 32">
		<path
			fill="currentColor"
			d="M24.7272949,4.0000148H7.2727051C5.465271,4.0000148,4,5.4652247,4,7.2727199v17.4545288
			c0,1.8074951,1.465271,3.2727661,3.2727051,3.2727661h10.9091187L28,18.181839V7.2727199
			C28,5.4652247,26.534729,4.0000148,24.7272949,4.0000148z M19.0064087,24.2953644
			c0.0314331-3.2001343,0.1884155-4.0835571,0.6951294-4.5830078c0.5082397-0.5010376,1.440918-0.6669312,4.5914307-0.7035522
			L19.0064087,24.2953644z M26,17.0000153c-5.3196411,0-6.53479,0.1369629-7.7025146,1.2880249
			C17.1282349,19.440567,16.9996948,20.5705719,17,25.8275299c0,0.0858765,0,0.0858765,0,0.1724854H7.111084
			C6.4974365,26.0000153,6,25.5025177,6,24.8888702V7.1110988c0-0.6136475,0.4974365-1.111084,1.111084-1.111084h17.777832
			C25.5025635,6.0000148,26,6.4974513,26,7.1110988V17.0000153z"
		/>
	</Icon>
);

export default AnnotationsIcon;
